import { Meeting } from "../domain/api/Meeting";
import config from "../config";
import handler from "./health/responseHandler";
import { fetchRetry } from "./fx/fetchRetry";

export default class MeetingsDataService {

    public static getFreeMeetAsync(): Promise<Meeting> {
        return fetchRetry(`${config.meet.hosts.api}/meetings/free`, {
            credentials: "omit",
            headers: {
                "Content-Type": "application/json",
            },
            method: "POST",
        })
        .then(r => handler.onJson(r))
        .catch(e => handler.onError(e));
    }

    public static getQuickMeetAsync(): Promise<Meeting> {

        if (!config.token) {
            return this.getFreeMeetAsync();
        }

        return fetchRetry(`${config.meet.hosts.api}/meetings`, {
            body: JSON.stringify({}),
            credentials: "omit",
            headers: {
                "Authorization": `bearer ${config.token!.value}`,
                "Content-Type": "application/json",
            },
            method: "POST",
        })
        .then(r => handler.onJson(r))
        .catch(e => handler.onError(e));
    }
}
